module.exports = __webpack_public_path__ + "static/media/Afterpay_Logo.aaf90b8e.png";